import { render, staticRenderFns } from "./BeckInterpretationPDF.vue?vue&type=template&id=45bf54f0&"
import script from "./BeckInterpretationPDF.vue?vue&type=script&lang=js&"
export * from "./BeckInterpretationPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports